import { render, staticRenderFns } from "./question.vue?vue&type=template&id=41c321fe&scoped=true&"
import script from "./question.vue?vue&type=script&lang=js&"
export * from "./question.vue?vue&type=script&lang=js&"
import style0 from "./question.vue?vue&type=style&index=0&id=41c321fe&lang=less&scoped=true&"
import style1 from "./question.vue?vue&type=style&index=1&id=41c321fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c321fe",
  null
  
)

export default component.exports